import React from 'react';
import styles from './TasksHeader.module.css';

const TasksHeader = () => {
  return (
    <div className={styles.leaderboardHeader}>
      <div className={styles.leaderboardHeader__content}>
        <div className={styles.leaderboardHeader__title}>
          Выполняй задания <br /> и зарабатывай
        </div>
        <div className={styles.subtitle}>
          Внутри можно получить уникальные подарки
        </div>
      </div>
    </div>
  );
};

export default TasksHeader;
